import { render, staticRenderFns } from "./PerformanceUnitDetail.vue?vue&type=template&id=3335e1f7&scoped=true&"
import script from "./PerformanceUnitDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceUnitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335e1f7",
  null
  
)

export default component.exports